import React from "react";
// Components
import MainTable from '../../Components/Tables/Main/MainTable'
import ButtonSwitchBetweenTables from '../../Components/Buttons/ButtonSwitchBetweenTables'
// Hooks
import { useAlerts } from "../../Hooks/useAlerts";
import { useVehicles } from "../../Hooks/useVehicles";
import { useHistory } from "react-router-dom";
// Libraries
import DateFnsUtils from '@date-io/date-fns';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
// Constants
import { alertTypes, resolveTimezoneOffsetError } from "../../CommonConstants";
const propertyAlerts = { ...alertTypes }
delete propertyAlerts.maintenance

const Alerts = () => {
    const [alertsData, addAlert, updateAlert, deleteAlert] = useAlerts();

    const history = useHistory();

    const navigateToMaintenanceAlerts = () => history.push('/alerts/maintenance')

    let [vehicles] = useVehicles(true);
    vehicles = vehicles.reduce(
        function (acc, cur) {
            const { id, brand, model, patent, year } = cur;
            acc[id] = `${brand} ${model} ${patent} ${year}`;
            return acc;
        },
        {}
    )

    const columns = [
        { title: "Id", field: "id", hidden: true },
        { title: "Descripción", field: "description" },
        { title: "Tipo", field: "type", lookup: propertyAlerts, editable: "onAdd" },
        { title: "Días de preaviso", field: "daysForewarning", type: "numeric" },
        { title: "Vehículo", field: "vehicleId", lookup: vehicles, editable: "onAdd" },
        {
            title: "Fecha de acción", field: "actionDate", defaultSort: 'asc', type: "date",
            render: row => row.actionDate ? <span>{resolveTimezoneOffsetError(row.actionDate, 'dd/MM/yyyy')}</span> : <span></span>,
            editComponent: props => (
                <MuiPickersUtilsProvider utils={DateFnsUtils}
                    locale={props.dateTimePickerLocalization}>
                    <DatePicker
                        format="dd/MM/yyyy"
                        value={props.value ? resolveTimezoneOffsetError(props.value) : null}
                        onChange={props.onChange}
                        clearable
                        InputProps={{
                            style: {
                                fontSize: 13,
                            }
                        }}
                    />
                </MuiPickersUtilsProvider>
            )
        }
    ];

    return (
        <div>
            <ButtonSwitchBetweenTables text={'Ver alertas de mantenimiento'} onClick={navigateToMaintenanceAlerts} />
            <MainTable
                title="Alertas"
                columns={columns}
                data={alertsData}
                requiredFields={["description", "actionDate", "type", "vehicleId", "daysForewarning"]}
                deleteText="Se desactivará la alerta"
                onRowAdd={async (newData) => {
                    const dataToSave = { ...newData }
                    dataToSave.actionDate = dataToSave.actionDate ? resolveTimezoneOffsetError(dataToSave.actionDate, 'yyyy-MM-dd') : null
                    delete dataToSave.vehicleId
                    await addAlert(dataToSave, +newData.vehicleId)
                }}
                onRowUpdate={async (newData) => {
                    const dataToSave = { ...newData }
                    delete dataToSave.fileId
                    delete dataToSave.id
                    delete dataToSave.type
                    delete dataToSave.vehicleId
                    dataToSave.actionDate = dataToSave.actionDate ? resolveTimezoneOffsetError(dataToSave.actionDate, 'yyyy-MM-dd') : null
                    await updateAlert(dataToSave, newData.id)
                }}
                onRowDelete={async (newData) => await deleteAlert(newData.id)}
            />
        </div>)
}

export default Alerts


// WEBPACK FOOTER //
// ./src/Containers/Alerts/Alerts.js